module.exports = __webpack_public_path__ + "static/media/swiss-army-knife.90254f4c.svg";